<template>
    <div class="py-10 ">
        <div class=" flex flex-col gap-6 pb-10 text-left">
            <h2>{{ model.heading }}</h2>
            <p>{{ model.description }}</p>
        </div>
        <div class="grid lg:grid-cols-2 gap-5 text-left bg-sand">
            <a :href="shortcut.url" :title="`Finn ut mer om ${shortcut.title}`" v-for="shortcut in model.shortcuts"
               :key="shortcut.url"
               class="flex flex-col gap-4 lg:flex-row bg-white p-5 lg:p-10 h-full justify-center lg:items-center group">
                <div v-if="shortcut.image" class="w-fit">
                    <div class="w-[60px] h-[60px]">
                        <img
                            :src="`${shortcut.image}?${imageParams}&${shortcut.imageResizerParams}`"
                            alt="shortcut icon"
                            class="object-cover"
                        />
                    </div>
                </div>
                <div class="w-full">
                    <h3 class="font-medium text-2xl group-hover:underline line-clamp lines-2">
                        {{ shortcut.title }}
                    </h3>
                    <div v-if="shortcut.extract" v-html="shortcut.extract" class="line-clamp lines-2"/>
                </div>
                <div class="pl-0 pr-2 group-hover:pr-0 group-hover:pl-2 transition-all">
                    <font-awesome-icon icon="arrow-right" class="py-2.5 w-7 h-5"/>
                </div>

            </a>
        </div>
        <div class="text-right my-4" v-if="buttonLink !== null">
            <EpiLink :url="buttonLink" className="inline-block text-lg rounded-full bg-green-700 text-white px-6 py-2">
                {{ model.buttonText }} >
            </EpiLink>
        </div>
    </div>
</template>

<script>
import EpiLink from '@/Scripts/components/atoms/EpiLink/index.vue';
import LinedHeader from '@/Scripts/components/atoms/LinedHeader/LinedHeader.vue';

export default {
    props: ['model'],
    components: {
        EpiLink,
        LinedHeader,
    },
    data() {
        return {
            imageParams: 'scale=both&width=60&height=60',
            buttonLink: (
                (this.model.buttonLink && this.model.buttonLink.value && this.model.buttonLink.value.url)
                    ? this.model.buttonLink.value.url
                    : null
            )
        };
    },
    computed: {
        numShortcuts() {
            return this.model.shortcuts.length;
        }
    }
};
</script>
